export default __webpack_public_path__ + "static/media/closeIcon.bc18a029.svg";